module.exports = __webpack_public_path__ + "static/media/gremio.e5e4ef00.svg";